import React from 'react';
import ViewCoupon from 'containers/Coupons/ViewCoupon';

const ViewCouponPage = () => <ViewCoupon />;

export default ViewCouponPage;
